export default __webpack_public_path__ + "static/media/discord.95ad8e3b.jpg";